import { Scene } from "../system/Scene";
import * as PIXI from 'pixi.js'

import { App } from "../system/App";
import { Graph } from "./Graph";
import { Path } from "./Path";
import { state } from "@system/state/AppState";
// import { elapsedTime } from "@system/CrashRoyale";
import { elapsedTime } from "@system/ClassicCrash";
import { SdkModal } from "./SdkModal";
 

export class Game extends Scene {

  path: Path = new Path()
  graph: Graph | null = null
  lastUpdateTime: number = Date.now(); // to store the last update time
  elapsedTime: number = 0; // to store the elapsed time
  animate: (ticker: PIXI.Ticker) => void
  startAnimate: boolean = false //state to allow only one animation at a time

 



  constructor() {
    super()

    this.create()
    // this.update()

    //animation callback
    this.animate = (ticker: PIXI.Ticker) => {
      const currentTime = Date.now();
      const deltaTime = currentTime - this.lastUpdateTime
      this.elapsedTime += deltaTime;
      this.lastUpdateTime = currentTime;

      this.path.start()
      if (state.getState().isCurveGreen) {
        this.path.setPathGreen()
      } else {
        this.path.resetPathColor()
      }
      if (elapsedTime >= App.config.axis.xStartTime) {
        this.graph?.updateXlabels();
      }
      if (elapsedTime >= App.config.axis.yStartTime) {
        this.graph?.updateYlabels();
      }
    }


  }


  create(): void {
    this.createGraph()

  }



  createGraph() {
    this.graph = new Graph()
    this.container.addChild(this.graph.container)
  }

  update(): void {
    if (!this.startAnimate) {
      this.startAnimate = true
      this.resetAnimation()
      App.app.ticker.add(this.animate)
    }

  }

  resize(newWidth: number, newHeight: number): void {
    // this.graph?.resize(newWidth, newHeight)

    //recreate graph
    this.container.removeChild(this.graph?.container!)
    this.graph?.destroy()

    this.createGraph()
  }


  resetAnimation() {
    this.lastUpdateTime = Date.now();
    this.elapsedTime = 0;
  }


  //stop the animation - delete the path
  stop(): void {
    this.startAnimate = false
    App.app.ticker.remove(this.animate)
    this.graph?.reset()
    this.path.stop()
  }


  pause() {
    this.startAnimate = false
    App.app.ticker.remove(this.animate)
    this.graph?.pauseLabels()

    this.path.pause()
  }

  destroy(): void { }

}